import { render } from "./HealthCheck.vue?vue&type=template&id=001a9b12&ts=true"
import script from "./HealthCheck.vue?vue&type=script&lang=ts"
export * from "./HealthCheck.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__